import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import { Homepage } from './componenet/homepage';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Contactus } from './componenet/contactus';
import { Aboutme } from './componenet/aboutme';
import { Kundalianalis } from './componenet/kundalianalysis';
import { Kundalimatching } from './componenet/kundalimatching';
import { Marriage } from './componenet/marriagerelationships';
import { Career } from './componenet/career';
import { Finance } from './componenet/finance';
import { Health } from './componenet/health';
import { Muhart } from './componenet/muhart';
const root = ReactDOM.createRoot(document.getElementById('root'));
let allroute=createBrowserRouter(
[
{

  path:'/',
  element:<Homepage></Homepage>
},

{

  path:'contactus',
  element:<Contactus />
},
{

  path:'astrologergurgaon',
  element:<Aboutme></Aboutme>
},
{

  path:'kundalimatching',
  element:<Kundalimatching></Kundalimatching>
},
{

  path:'Career-Guidance',
  element:<Career></Career>
},
{

  path:'Muhart',
  element:<Muhart/>
},

{

  path:'medical-astrology',
  element:<Health/>
},
{

  path:'business-and-finance',
  element:<Finance></Finance>
},

{

  path:'/relationship',
  element:<Marriage></Marriage>
},

{
path:'/kundalianalysis',
element:<Kundalianalis ></Kundalianalis>
}




]


)




root.render(
  <React.StrictMode>
   <RouterProvider router={allroute}></RouterProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
